// extracted by mini-css-extract-plugin
export default {"toolbar":"styles_toolbar__FWPgS","filters":"styles_filters__hqDP9","search":"styles_search__KV0AJ","switchLabel":"styles_switchLabel__ITDvL"};